import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {AfregningDto} from 'src/app/api/models/OK/Egis/Service/Models/DTO/afregning-dto';
import {ServiceaftaleDto} from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import {OpkraevningsIntervalDialogComponent} from 'src/app/components/aftale/create/forms/abonnement-form/opkraevnings-interval-dialog/opkraevnings-interval-dialog.component';
import {KreditnotaDialogData, KreditnotaDialogResponse} from 'src/app/components/aftale/models';
import {OpkraevningScopeEnum} from "src/app/api/models/OK/Egis/Service/Models/Entities/Enums/opkraevning-scope-enum";

@Component({
    selector: 'app-kreditnota-dialog',
    templateUrl: './kreditnota-dialog.component.html',
    styleUrls: ['./kreditnota-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KreditnotaDialogComponent implements OnInit {
  form: UntypedFormGroup;

  afregning: AfregningDto;
  serviceaftale: ServiceaftaleDto;
  unsubscribe$ = new Subject<void>();
  opkraevningScopePartner = OpkraevningScopeEnum.Partner;

  get title(): string {
    if(this.afregning.opkraevningScope == OpkraevningScopeEnum.Partner) return "Opret tilbageførsel";
    return "Opret kreditnota";
  }

  get erAbonnement() {
    return this.afregning.type == 'Abonnement';
  }

  get note() {
    return this.form.get('note');
  }

  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialogRef<OpkraevningsIntervalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: KreditnotaDialogData
  ) {
    this.afregning = data.afregning;
    this.serviceaftale = data.serviceaftale;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      note: [null, [Validators.maxLength(500), Validators.required]],
      nyFaktura:[false],
      partnerkorrektion:[false]
    });
  }

  save() {
    const response: KreditnotaDialogResponse = {
      comment: this.note.value,
      nyFaktura:this.form.get('nyFaktura').value,
      partnerkorrektion:this.form.get('partnerkorrektion').value
    };
    this.dialog.close(response);
  }
}
